import React from 'react'
import { observer } from 'mobx-react'
import { Form, Input } from 'components/Form'
import Icon from 'components/Icon'
import ErrorLabel from 'components/ErrorLabel'
import './styles.sass'

const BrokerLogin = ({ provider }) => {
  const brokerage = provider.selectedBrokerage
  return (
    <div className="brokerage-login">
      {!provider.account &&
        // Only show the back button when we haven't created an account yet.
        <button className="button is-icon-only" onClick={() => provider.reset()}>
          <Icon material name="arrow back" />
        </button>
      }

      <div className="brokerage-name">
        {brokerage.logo
          ? <img src={brokerage.logo} alt={brokerage.name} className="brokerage-logo" />
          : brokerage.name
        }
      </div>
      {brokerage.notes &&
        <div className="brokerage-notes">
          {brokerage.notes}
        </div>
      }

      <Form onSubmit={() => provider.authenticate()}>
        <Input
          placeholder={brokerage.username || 'Username'}
          field="username"
          model={provider}
        />
        <Input
          placeholder={brokerage.password || 'Password'}
          field="password"
          type="password"
          model={provider}
        />
        <button className="button is-action">Log in</button>
      </Form>
      <div className="has-spacing-top--less">
        <ErrorLabel>{provider.error}</ErrorLabel>
      </div>
    </div>
  )
}

export default observer(BrokerLogin)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/BrokerLogin/index.jsx